function isPrevDate(date: string) {
  const todayDate = new Date();
  const today = `${todayDate.getFullYear()}-${
    todayDate.getMonth() + 1
  }-${todayDate.getDate()}`;
  return new Date(date) < new Date(today);
}

export default isPrevDate;
